export type AudioSegment = {
  start: number;
  end: number;
};

export function clampAudioTime(value: number, duration: number): number {
  const safeDuration = Number.isFinite(duration) && duration > 0 ? duration : 0;
  const safeValue = Number.isFinite(value) ? value : 0;
  return Math.min(Math.max(safeValue, 0), safeDuration);
}

export function normalizeAudioSegment(
  start: number | null,
  end: number | null,
  duration: number
): AudioSegment | null {
  if (start == null || end == null || !Number.isFinite(duration) || duration <= 0) return null;
  const normalizedStart = clampAudioTime(start, duration);
  const normalizedEnd = clampAudioTime(end, duration);
  if (normalizedEnd <= normalizedStart) return null;
  return { start: normalizedStart, end: normalizedEnd };
}

export function getLoopRestartTime(
  currentTime: number,
  start: number | null,
  end: number | null,
  duration: number
): number | null {
  const segment = normalizeAudioSegment(start, end, duration);
  if (!segment) return null;
  return currentTime >= segment.end - 0.03 ? segment.start : null;
}
